import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldOperatorDropdown } from '@/(routers)/boards/editor/block/definitions/fields/fieldOperatorDropdown';
import { FieldStyledBadgeLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledBadgeLabel';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';

const POSITION_OPTIONS = {
    orange: [{ value: 'UPPER_LEFT', label: '左上' }],
    blue: [
        { value: 'UPPER_LEFT', label: '左上' },
        { value: 'UPPER_RIGHT', label: '右上' },
        { value: 'LOWER_LEFT', label: '左下' },
        { value: 'LOWER_RIGHT', label: '右下' },
    ],
};

const TYPE_OPTIONS = [
    { value: 'X', label: 'X軸の加速度' },
    { value: 'Y', label: 'Y軸の加速度' },
    { value: 'Z', label: 'Z軸の加速度' },
    { value: 'ABS', label: '加速度の大きさ' },
];

const TYPE_COLOURS: Record<string, string> = {
    ABS: CATEGORIES.sensing.color,
    X: '#cc0000',
    Y: '#00cc00',
    Z: '#0000cc',
};

defineBlock({
    type: 'accelerometer',
    colour: CATEGORIES.sensing.color,
    tooltip: '加速度センサーの値を読み取ります',
    movable: true,
    deletable: true,
    output: 'Number',
    inputs: [
        {
            kind: 'dummy',
            fields: [
                { type: 'image', icon: { src: '/images/block/accelerometer.svg', size: 65 } },
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('加速度センサー', { fontSize: 15, fontWeight: 'bold' }),
                },
                {
                    type: 'field',
                    instance: () => new FieldStyledBadgeLabel('加速度'),
                },
                { type: 'label', text: ' ' },
                {
                    type: 'field',
                    name: 'POSITION',
                    instance: () => new FieldOperatorDropdown(POSITION_OPTIONS.orange),
                },
                { type: 'label', text: 'で' },
                {
                    type: 'field',
                    name: 'TYPE',
                    instance: () => {
                        const field = new FieldOperatorDropdown(TYPE_OPTIONS);
                        field.setRectColour(TYPE_COLOURS['ABS']);
                        field.setOnValueChange((value: string) => {
                            field.setRectColour(TYPE_COLOURS[value]);
                        });
                        return field;
                    },
                },
                { type: 'label', text: 'を計測する ' },
            ],
        },
    ],
    onBoardChange: (block, board) => {
        const field = block.getField('POSITION') as FieldOperatorDropdown | null;
        if (!field) return;
        field.setOptions([...POSITION_OPTIONS[board]]);
    },
});
